import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    control: null
  },
  mutations: {
  },
  actions: {
    async getSpacetypeInfo ({ state, dispatch }, spaceid) {
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-spacetype-by-spaceid&siteid=${API.SITE_INFO.site}&spaceid=${spaceid}`)
        return res.data.message
      } catch (ex) {
        console.log(ex.reponse)
        return false
      }
    },
    async getControlData ({ state, dispatch }, data) {
      const file = data.subtype ? `control/${data.spacetype}/${data.subtype}.json` : `control/${data.spacetype}.json`
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${API.SITE_INFO.site}&file=${file}`)
        return res.data.message
      } catch (ex) {
        console.log(ex.reponse)
        return false
      }
    },
    async getControl ({ state, dispatch }, spaceid) {
      return dispatch('getSpacetypeInfo', spaceid).then((spacetype) => {
        if (spacetype) {
          const subtype = store.state.authentication.subtype
          const spaceData = {
            spacetype: spacetype,
            ...(subtype && subtype !== '0') && {
              subtype: subtype
            }
          }
          return dispatch('getControlData', spaceData).then((res) => {
            return res
          })
        } else {
          return false
        }
      })
    },
    async getRoomStatus ({ state }) {
      const siteInfo = store.state.authentication
      const ota = store.state.authentication.public ? await store.dispatch('authentication/getOtaKey') : store.state.authentication.k
      try {
        const res = await axios.get(`${API.BASE_URL}/${siteInfo.site}/${siteInfo.space}/rcu/${ota}`)
        return res.data.message
      } catch (ex) {
        console.log(ex.response)
        return false
      }
    },
    async setRoomControl ({ state }, data) {
      const siteInfo = store.state.authentication
      const ota = store.state.authentication.public ? await store.dispatch('authentication/getOtaKey') : store.state.authentication.k
      try {
        const res = await axios.put(`${API.BASE_URL}/${siteInfo.site}/${siteInfo.space}/rcu/${ota}`, {
          version: 'v2',
          ...data
        })
        return res
      } catch (ex) {
        console.log(ex.response)
        return false
      }
    }
  },
  getters: {
  }
}
